<template>
  <th v-if="isHeader">
    {{'Actions' | trans}}
  </th>
  <td class="custom-action-buttons-td" v-else>
    <div class="custom-actions">
      <button class="btn btn-primary mb-1 edit-button" @click="itemAction('edit', rowData, rowIndex)"><i class="icons icon-note"></i></button>
      <form style="display:inline-block; vertical-align:middle" :action="$store.getters.apiUrl + '/printworkorder/' + rowData.id" target="_blank" method="POST">
        <input name="token" type="hidden" :value="$auth.token()"></input>
        <button type="submit" class="btn btn-primary mb-1 print-button" @click="itemAction('print', rowData, rowIndex)" style="cursor:pointer">
            <i class="icons icon-printer"></i>
        </button>
      </form>
      <button class="btn btn-danger mb-1 delete-button" @click="itemAction('delete', rowData, rowIndex)"><i class="icons icon-trash"></i></button>
    </div>
  </td>
</template>

<script>
import VuetableFieldMixin from 'vuetable-2/src/components/VuetableFieldMixin'

export default {
  mixins: [VuetableFieldMixin],
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  methods: {
    itemAction (action, data, index) {
      if (action === 'delete') {
        var confirmMessage = this.$t('Delete work order?') + '\n\n' + this.$t('This will permanently delete the work order including all order rows and attached risk reports.')
        if (confirm(confirmMessage)) {
          this.$router.push({ path: '/workorder/' + action + '/' + data.id })
        }
      } else if (action === 'print') {
        this.$parent.$parent.$parent.$refs.workordertable.$refs.vuetable.selectId(data.id)
        // console.log(this.$parent.$parent.$parent.$refs.workordertable.$refs.vuetable)
        // window.open('/#/print/workorder/' + data.id, '_blank')
      } else {
        this.$router.push({ path: '/workorder/' + action + '/' + data.id })
      }
    }
  }
}
</script>
<style scoped> 
@media (max-width:640px){
  .print-button {
    display: none
  }
}
</style>


// WEBPACK FOOTER //
// OrderListActions.vue?5482a055